
export enum BookingKind {
    BIN = 'bin',
    BAG = 'bag',
}

export class BookingKindHelper {

    /**
     * Get options
     */
    static getOptions(): BookingKind[] {
        return [
            BookingKind.BIN,
            BookingKind.BAG,
        ];
    }

    /**
     * Get booking kind
     * @param kind The kind of book
     */
    static getBookingKind(kind: string): BookingKind {
        switch (kind) {
            case 'bin':
                return BookingKind.BIN;
            case 'bag':
                return BookingKind.BAG;
        }

        return BookingKind.BIN;
    }

    /**
     * Get booking kind label
     * @param bookingKind kind
     */
    static getBookingKindLabel(bookingKind: BookingKind): string {

        switch (bookingKind) {
            case BookingKind.BIN:
                return 'Skip Bin';
            case BookingKind.BAG:
                return 'Waste Bag';
        }
    }

    /**
     * Get booking kind slug
     * @param bookingKind kind
     */
    static getBookingKindSlug(bookingKind: BookingKind): string {
        switch (bookingKind) {
            case BookingKind.BIN:
                return 'bin';
            case BookingKind.BAG:
                return 'waste bag';
        }
    }
}
